import { render, staticRenderFns } from "./color-input.vue?vue&type=template&id=98bea7b8&scoped=true&"
import script from "./color-input.vue?vue&type=script&lang=ts&"
export * from "./color-input.vue?vue&type=script&lang=ts&"
import style0 from "./color-input.vue?vue&type=style&index=0&id=98bea7b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bea7b8",
  null
  
)

export default component.exports